import { FONTS, IS_LOGO_TEXT_SEPARATED } from 'src/constants';

export const createFontsTags = (isHebrewVersion: boolean) => {
  const mainFont = isHebrewVersion ? FONTS.ARIMO : FONTS.DM_SANS;
  const monoFont = isHebrewVersion ? FONTS.ARIMO : FONTS.ROBOTO_MONO;
  const fontsSet = [mainFont.name, monoFont.name];

  const fontStylesFragment = document.createDocumentFragment();

  const getFontFamilyParam = (fontName: string) => {
    const encodedFontName = fontName.replace(/ /g, '+');
    return `family=${encodedFontName}:wght@400;500;700`;
  };

  const googleFontLink = document.createElement('link');
  googleFontLink.rel = 'stylesheet';
  googleFontLink.href = `https://fonts.googleapis.com/css2?${
    IS_LOGO_TEXT_SEPARATED ? 'family=Mako&family=PT+Sans+Narrow:wght@400;700&' : ''
  }${fontsSet
    .filter((font, i) => fontsSet.indexOf(font) === i)
    .map(getFontFamilyParam)
    .join('&')}&display=swap`;
  fontStylesFragment.appendChild(googleFontLink);

  const fontStyleTag = document.createElement('style');
  fontStyleTag.textContent = `:root{
    --font-main: "${mainFont.name}", ${mainFont.type};
    --font-mono: "${monoFont.name}", ${monoFont.type};
  }`;
  fontStylesFragment.appendChild(fontStyleTag);

  document.head.appendChild(fontStylesFragment);

  return () => {
    googleFontLink.remove();
    fontStyleTag.remove();
  };
};
